<template>
  <div>
    <section class="page-banner" style="background-image: url(/static/img/tuotibg.png);">
            <div class="container">
                <div class="banner-tip">
                    <h2 class="banner-title">错题本</h2>
                    <div class="bread-crumbs">
                      Error edition
                    </div>
                </div>
            </div>
          </section>  
    <section class="course-area course-area4">
    <section>
      <div class="container section-heading">
                    <div class="twotip">
                        <img src="/static/img/apps_fill.png" class="courses-showing-icon"/><span class="courses-showing-text">共{{ intTotal }}道错题记录</span>
                      </div>
                    <div class="search-box">
                        <input type="search" v-model="searchWords" placeholder="输入关键字...">
                        <button type="submit" @click="toPage(1)"><img src="/static/img/search-line.png" width="21" height="21"/></button>
                    </div>
                </div>
     </section>
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab2">
                            <div class="row course-block course-list-block">
                                <div class="col-lg-12" v-for="(qust,index) in errQusts" :key="index">
                                    <div class="course-item">
                                        <div class="course-content" style="width: 100%;border-left:1px solid rgba(127, 136, 151, 0.2);">
                                            <p class="course__label">
                                                <el-tag type="success" style="margin-right:11px">题型：{{qust.questiontype}}</el-tag>
                                                 <el-tag type="success">科目：{{getQustInfo(qust).type}}</el-tag>
                                            </p>
                                            <div class="test_printcontent_nr_tt" v-if="qust.questiontype!='复合题'">
                                                <font style="color: #000;"><i class="el-icon-star-on" style="color: #FF8600FF;"></i>{{getQustInfo(qust).title}}</font>
                                                <br v-if="qust.filepath"/> <img v-if="qust.filepath" :src="`${global.remoteIp}/uploads/${qust.filepath}`" alt="" style="width: 60%;">
                                                <br v-if="qust.filepath"/><br v-if="qust.filepath"/>
                                            </div>
                                            <div class="test_printcontent_nr_tt" v-else>
                                                <font style="color: #000;"><i class="el-icon-star-on" style="color: #FF8600FF;"></i><p v-html="getQustInfo(qust).title"></p></font>
                                            </div>
                                            <div class="test_printcontent_nr_main" style="margin-left: 3px; margin-top: 5px;">
                                                <ul v-if="getQustInfo(qust).foption">
                                                    <li v-for="(option,indexex) in getQustInfo(qust).foption.split(',jh,')" :key="indexex" style=" display:inline;margin-right: 25px">
                                                        <label style="font-weight:500" :class="getColor(option.slice(0, 1), qust.correctanswer, qust.useranswer)">
                                                            {{option.slice(0,2)}}
                                                            <p  style="display: inline;">{{option.slice(2)}}</p>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div >
                                                <span class="text-info mb-1 " v-if="getQustInfo(qust).level">[ 题目难度：{{getQustInfo(qust).level}} ]</span>
                                                
                                            </div>
                                            <div style="line-height: 23px;">
                                                <span class="text-success mb-1 " v-if="qust.correctanswer">[ 正确答案：{{qust.correctanswer}} ]</span>
                                                <span class="text-danger mb-1 mb-1" >[ 你的答案：{{qust.useranswer}} ]</span>
                                            </div>
                                            <div >
                                                <template><span class="text-primary mb-1" >[ 答案解析：{{getQustInfo(qust).remarks}} ]</span></template>
                                            </div>
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-12 -->
                            </div>
                        </div>
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                           <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        errQusts:[],
        plateId:"",
        searchType:"",
        paperSubs:[],
        searchWords:"",
        searchSub:""
    };
  },

  components: {},

  computed: {
      
  },
  watch:{
      searchType(newVal){
          if(newVal)
          {
              this.toPage(0);
          }
      }
  },
  mounted() {
    this.$axios.get(`/api/questionFormalInfos?page=1&limit=6&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.errQusts=res.data.data;
          this.intTotal = res.data.total;
        //           var temp = [...res.data.data, ...res.data.data, ...res.data.data, ...res.data.data, ...res.data.data, ...res.data.data, ...res.data.data, ...res.data.data, ...res.data.data];
        // this.intTotal = 9;
        // this.errQusts = temp;
        }
    });
  },

  methods: {
    getColor(index, result1, result2) {
      if (index == result1) {
        return 'colorgren';
      }
      if (index == result2) {
        return 'colorgred';
      }
    },
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      setSearchSubs(searchSub){
          this.searchSub = searchSub;
      },
      toPage(intcount){
        if(intcount)this.intCurrent = intcount;
        var searchConditions = "";
        if (this.searchWords) {
          searchConditions += "&questiontype=$regex:" + this.searchWords;
        }
        this.$axios.get(`/api/questionFormalInfos?page=${this.intCurrent}&limit=6&sort=-createdAt${searchConditions}`).then((res) => {
            if (res.data) {
                this.errQusts=res.data.data;
                 this.toTop();
            }
        });
      },
      getQustInfo(errQust){
        switch(errQust.questiontype)
        {
            case "判断题": 
                return errQust.examJudgementQuestion;
            case "单选题": 
                return errQust.examSingleSelection;
            case "多选题":
                return errQust.examMultipleSelection;
            case "填空题":
                return errQust.examCompletQuestion;
            case "复合题":
                return errQust.examCompoundQuestion;
            case "问答题":
                return errQust.examLargeQuestion;
        }
      },
      getTimediff(starttime, endtime){
            console.log(starttime)
            let start = new Date(starttime);
            let end = new Date(endtime);
            let time = end - start;
            console.log(time);
            //计算出相差天数
            var days=Math.floor(time/(24*3600*1000))
            
            //计算出小时数

            var leave1=time%(24*3600*1000)    //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))
            //计算相差分钟数
            var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))
            //计算相差秒数
            var leave3=leave2%(60*1000)      //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            return `${('00'+hours).slice(-2)}:${('00'+minutes).slice(-2)}:${('00'+seconds).slice(-2)}`
        },
      dateFormat(date, format){
            var o = {
            "M+" : date.getMonth()+1, //month
            "d+" : date.getDate(), //day
            "h+" : date.getHours(), //hour 24
            "H+" : date.getHours(), //hour 24
            "m+" : date.getMinutes(), //minute
            "s+" : date.getSeconds(), //second
            "q+" : Math.floor((date.getMonth()+3)/3), //quarter
            "S" : date.getMilliseconds() //millisecond
            };

            if(/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            }

            for(var k in o) {
                if(new RegExp("("+ k +")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
                }
            }
            return format;
        },
         NewDate(str){ 
            if(!str){
                return 0;
            }
            let arr=str.split(" ");
            let d=arr[0].split("-");
            let t=arr[1].split(":");
            var date = new Date();
            date.setUTCFullYear(d[0], d[1] - 1, d[2]);
            date.setUTCHours(t[0], t[1], t[2], 0);
            return date;
        },
       
  }
}

</script>
<style scoped>

.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapper{
	width: 1198px;
	height: 93px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
.course-item{
    width: 1198px;
    height: auto;
    margin-bottom:40px;
}
.course-content{
  width: 1198px;
	height: auto;
	background: #FAFAFA;
border: 1px solid #E9E9E9;
border-radius: 5px;
background: linear-gradient(to bottom,#ffffff 50%, #FAFAFA 80%);
	margin: auto;
	padding: 15px;
}
/* two search s*/
.section-heading{
  display: flex;
  justify-content: space-between;
}
.twotip {
  padding-left:21px ;
  padding-right: 35px;
  height: 66px;
  background: #4462CF;
  box-shadow: 0px 10px 29px 0px rgba(68, 98, 207, 0.39);
  border-radius: 5px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.search-box input{
  border: 0;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  width: 235px;
  height: 66px;
  background: #F5F7FF;
}
.search-box input::placeholder{
  color: #B7B7B7;
}
.search-box input[type="search"] {
  height: 66px;
}
.search-box button {
  background: #F5F7FF;
  border: 0;
  height: 66px;
  line-height: 66px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-box button{
  padding: 0 20px;
}
.sorting {
  margin-left: 270px;
  position: relative;
  display: flex;
  min-width: 320px;
  background: #F5F7FF;
  border-radius: 5px;
  height: 66px;
  padding-left: 22px;
}

.sorting p {
  font-size: 20px;
  color: #000000;
  line-height: 66px;
  font-weight: 600;
  margin: 0;
}

.sorting select {
  width: 145px;
  height: 100%;
  line-height: 66px;
  outline: none;
  margin: 0;
  border: 0;
  padding: 0 10px;
  color: #BFBEC0;
  font-size: 20px;
  font-weight: 400;
  -webkit-user-select: none;
  user-select: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.sorting:after {
  content: "\33";
  font-family: 'ElegantIcons';
  display: inline-block;
  font-size: 20px;
  line-height: 66px;
  color: #000000;
  position: absolute;
  font-weight: 600;
  right: 18px;
  top: 0;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
/* two search e*/
/* fenyeqi s */
.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #4462CF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #EEEEEF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .btn-prev {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .btn-next {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;

}

.pagination-wrap>>>.el-pagination .btn-prev .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination .btn-next .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination {
  width: 1200px;
  text-align: right;
  height: 35px;
  padding-top: 4px;
  padding-bottom: 40px;
}

.pagination-wrap>>>.el-pager {
  height: 35px;
}

.pagination-wrap>>>.el-pager li {
  padding: 0;
  font-size: 14px;
  color: #666666;
}
/* fenyeqi e */
.colorgren{
  color: #28a745;
}
.colorgred{
  color:#dc3545;
}
</style>